import * as React from "react";
import type { SVGProps } from "react";
const SvgDestroyInternalSilos = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={64}
    height={64}
    fill="none"
    {...props}
  >
    <path
      fill="#D3ECF8"
      fillRule="evenodd"
      d="M27.83 2.278a1.909 1.909 0 0 0-1.908 1.909V11.3a.875.875 0 0 1-1.75 0V4.187A3.659 3.659 0 0 1 27.83.527h.21a3.448 3.448 0 0 1 3.448 3.45c0 .937.76 1.698 1.699 1.698h.21a1.909 1.909 0 0 0 1.909-1.91V1.404a.875.875 0 0 1 1.75 0v2.363a3.659 3.659 0 0 1-3.659 3.659h-.21a3.448 3.448 0 0 1-3.449-3.449c0-.938-.76-1.698-1.698-1.698h-.21Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M25.047 61.264c11.878 0 21.507-9.63 21.507-21.507 0-11.878-9.629-21.507-21.507-21.507-11.878 0-21.507 9.629-21.507 21.507 0 11.878 9.63 21.507 21.507 21.507Zm0 2c12.983 0 23.507-10.525 23.507-23.507 0-12.983-10.524-23.507-23.507-23.507-12.982 0-23.507 10.524-23.507 23.507 0 12.982 10.524 23.507 23.507 23.507Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      fillRule="evenodd"
      d="M23.54 12.139c-.621 0-1.125.503-1.125 1.125v4h-1.75v-4a2.875 2.875 0 0 1 2.875-2.875h3a2.875 2.875 0 0 1 2.875 2.875v4h-1.75v-4c0-.622-.504-1.125-1.125-1.125h-3ZM20.928 23.396a.875.875 0 0 1-.553 1.107c-7.647 2.549-11.065 8.96-11.803 11.764a.875.875 0 0 1-1.692-.445c.848-3.223 4.6-10.199 12.941-12.98a.875.875 0 0 1 1.107.554Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="m42.576 36.664 6.568-.671h5.373l5.075 1.716 2.24 1.791v19.63l-4.33 2.686-6.866.82-8.06-.82-4.702-1.94V38.902l4.702-2.239Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M39.07 39.06c-.508.4-.61.7-.61.87 0 .17.102.47.61.87.497.392 1.272.784 2.306 1.129 2.06.686 4.963 1.126 8.209 1.126 3.246 0 6.148-.44 8.209-1.127 1.034-.344 1.809-.736 2.306-1.128.508-.4.61-.7.61-.87 0-.17-.102-.47-.61-.87-.497-.392-1.272-.783-2.306-1.128-2.061-.687-4.963-1.127-8.209-1.127-3.246 0-6.148.44-8.209 1.127-1.034.345-1.809.736-2.306 1.128Zm1.753-2.788c2.283-.761 5.38-1.217 8.762-1.217 3.382 0 6.48.456 8.762 1.217 1.137.379 2.12.849 2.837 1.414.707.557 1.276 1.309 1.276 2.244 0 .935-.57 1.687-1.276 2.244-.717.565-1.7 1.036-2.837 1.415-2.283.76-5.38 1.216-8.762 1.216-3.382 0-6.48-.455-8.762-1.216-1.137-.38-2.12-.85-2.837-1.415-.707-.557-1.276-1.309-1.276-2.244 0-.935.57-1.687 1.276-2.244.717-.565 1.7-1.035 2.837-1.414ZM37.585 48.389c.483 0 .875.391.875.875 0 .173.103.474.606.873.494.391 1.264.782 2.296 1.127 2.055.686 4.957 1.125 8.223 1.125 3.266 0 6.168-.44 8.223-1.125 1.032-.345 1.802-.736 2.296-1.127.503-.399.606-.7.606-.873a.875.875 0 1 1 1.75 0c0 .933-.564 1.685-1.27 2.244-.713.566-1.693 1.037-2.828 1.416-2.278.76-5.377 1.215-8.777 1.215-3.4 0-6.499-.455-8.777-1.215-1.135-.38-2.115-.85-2.829-1.416-.705-.559-1.269-1.31-1.269-2.244 0-.484.392-.875.875-.875Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M37.585 39.055c.483 0 .875.392.875.875v18.667c0 .173.103.474.606.873.494.391 1.264.782 2.296 1.127 2.055.686 4.957 1.125 8.223 1.125 3.266 0 6.168-.44 8.223-1.125 1.032-.345 1.802-.736 2.296-1.127.503-.399.606-.7.606-.873V39.93a.875.875 0 1 1 1.75 0v18.667c0 .933-.564 1.685-1.27 2.244-.713.566-1.693 1.037-2.828 1.416-2.278.76-5.377 1.215-8.777 1.215-3.4 0-6.499-.455-8.777-1.215-1.135-.379-2.115-.85-2.829-1.416-.705-.559-1.269-1.31-1.269-2.244V39.93c0-.483.392-.875.875-.875Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgDestroyInternalSilos;
